/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function GoBack({ text, btnText, path }) {
  const navigate = useNavigate();
  return (
    <div className="position-relative">
      <Button
        onClick={() => navigate(path || -1)}
        variant="link"
        className="text-decoration-underline fw-semi-bold text-800 mb-3 position-md-absolute p-0 top-0"
        style={{ left: '-18rem' }}
      >
        <FontAwesomeIcon icon="arrow-left" className="me-2" />
        {btnText || 'Back'}
      </Button>
      <h3 className="fs-2 fw-semi-bold text-md-center">{text}</h3>
    </div>
  );
}

export default GoBack;
